import CryptoJS from "crypto-js";

const secretKey = "ajcjasscjknasjscnajsncnassjcnlascnlasca62sc62as6c26a2sc62a6sc26ass2c62ass6c26as2sc6a2c62asc62a6sc060";

export function saveToStorage(key, data) {
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  localStorage.setItem(key, encrypted);
}

export function getFromStorage(key) {
  const encryptedData = localStorage.getItem(key);
  if (!encryptedData) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Giải mã thất bại:", error);
    return null;
  }
}

// Xóa dữ liệu
export function removeFromStorage(key) {
  localStorage.removeItem(key);
}
